import airPodsCool from "./md/airPodsCool.md";
import doYouNeedAnAppleTV from "./md/doYouNeedAnAppleTV.md";
import eraOfSmartWatches from "./md/eraOfSmartWatches.md";
import iPadReplacement from "./md/iPadReplacement.md";
import isChromebookStillaThing from "./md/isChromebookStillaThing.md";
import mackbookReview from "./md/mackbookReview.md";
import packingForTravel from "./md/packingForTravel.md";
import reviewingHomeMini from "./md/reviewingHomeMini.md";
import whatsOnMyiPhone from "./md/whatsOnMyiPhone.md";
import whatisJS from "./md/whatIsJS.md";
import surveyJS from "./md/surveyJS.md";
import learnReact from "./md/learnReact.md";
import learnGatsby from "./md/learnGatsby.md";

const articles = [
  {
    type: "fancy",
    articleId: "article-1",
    tag: ["Apple", "technology"],
    title: "What's on MY iPhone?",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://source.unsplash.com/1600x900/?phone",
    author: "https://source.unsplash.com/1600x900/?people",
    authorName: "Jose Walker",
    date: "4 May 2023",
    address: "sydney, australia",
    readTime: 5,
    articleData: whatsOnMyiPhone,
  },
  {
    type: "basic",
    articleId: "article-2",
    tag: ["google", "technology", "computer science"],
    title: "Is Chromebook Still a Thing",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://source.unsplash.com/1600x900/?nature",
    author: "https://source.unsplash.com/1600x900/?india",
    authorName: "Suzan Walker",
    date: "14 June 2023",
    address: "mumbai, India",
    readTime: 7,
    articleData: isChromebookStillaThing,
  },
  {
    type: "basic",
    articleId: "article-3",
    tag: ["Apple", "technology"],
    title: "Do You Need an Apple TV?",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://source.unsplash.com/1600x900/?water",
    author: "https://source.unsplash.com/1600x900/?apple",
    authorName: "John Doe",
    date: "25 September 2025",
    address: "Istanbul, Turkey",
    readTime: 2,
    articleData: doYouNeedAnAppleTV,
  },
  {
    type: "basic",
    articleId: "article-4",
    tag: ["review", "apple", "technology", "thoughts"],
    title: "MacBook Air 2018 Review",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://source.unsplash.com/1600x900/?google",
    author: "https://source.unsplash.com/1600x900/?usa",
    authorName: "arthur conan doyle",
    date: "11 December 2025",
    address: "New York, united states ",
    readTime: 3,
    articleData: mackbookReview,
  },
  {
    type: "basic",
    articleId: "article-5",
    tag: ["wearable", "fashion", "devices", "tips & tricks"],
    title: "The Era of Smartwatchs",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://source.unsplash.com/1600x900/?house",
    author: "https://source.unsplash.com/1600x900/?village",
    authorName: "Ivanovich Icanovna",
    date: "22 March 2022",
    address: "london, united kingdom ",
    readTime: 8,
    articleData: eraOfSmartWatches,
  },
  {
    type: "fancy",
    articleId: "article-6",
    tag: ["apple", "technology", "devices"],
    title: "iPad as a Notebook Replacement",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://source.unsplash.com/1600x900/?fort",
    author: "https://source.unsplash.com/1600x900/?people",
    authorName: "Jose Walker",
    date: "2 January 2023",
    address: "Shanghai, China",
    readTime: 4,
    articleData: iPadReplacement,
  },
  {
    type: "basic",
    articleId: "article-7",
    tag: ["apple", "wearable", "review"],
    title: "AirPods are Cool",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://source.unsplash.com/1600x900/?computer",
    author: "https://source.unsplash.com/1600x900/?food",
    authorName: "Maria Rodriguez",
    date: "22 January 2022",
    address: "Vaadhoo, Maldives",
    readTime: 6,
    articleData: airPodsCool,
  },
  {
    type: "fancy",
    articleId: "article-8",
    tag: ["Tips & Tricks", "life", "ideas"],
    title: "Packing for Travel",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://source.unsplash.com/1600x900/?colors",
    author: "https://source.unsplash.com/1600x900/?tree",
    authorName: "Sarah Brown",
    date: "12 May 2024",
    address: "Colombo, Sri Lanka",
    readTime: 4,
    articleData: packingForTravel,
  },
  {
    type: "basic",
    articleId: "article-9",
    tag: ["google", "technology", "review", "devices"],
    title: "Reviewing the Home Mini",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://source.unsplash.com/1600x900/?animals",
    author: "https://source.unsplash.com/1600x900/?india",
    authorName: "Suzan Walker",
    date: "1 April 2023",
    address: "Kushma, Nepal ",
    readTime: 3,
    articleData: reviewingHomeMini,
  },
  {
    type: "fancy",
    articleId: "article-10",
    tag: ["code", "technology", "javascript", "book"],
    title: "What is JavaScript? : Getting Started",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://raw.githubusercontent.com/getify/You-Dont-Know-JS/2nd-ed/get-started/images/cover.png",
    author: "https://source.unsplash.com/1600x900/?india",
    authorName: "Suzan Walker",
    date: "11 May 2023",
    address: "Kushma, Nepal ",
    readTime: 5,
    articleData: whatisJS,
  },
  {
    type: "basic",
    articleId: "article-11",
    tag: ["code", "technology", "javascript"],
    title: "Survey JavaScript",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://cdn.mos.cms.futurecdn.net/EzgdmaCQuT84bgDL4fhXZS-970-80.jpg.webp",
    author: "https://source.unsplash.com/1600x900/?tree",
    authorName: "Sarah Brown",
    date: "11 June 2022",
    address: "Kulu, India",
    readTime: 11,
    articleData: surveyJS,
  },
  {
    type: "basic",
    articleId: "article-12",
    tag: ["code", "technology", "javascript"],
    title: "Let's learn React",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://uploads.sitepoint.com/wp-content/uploads/2017/04/1493235373large_react_apps_A-01.png",
    author: "https://source.unsplash.com/1600x900/?people",
    authorName: "Jose Walker",
    date: "13 June 2022",
    address: "Shimla, India",
    readTime: 6,
    articleData: learnReact,
  },
  {
    type: "basic",
    articleId: "article-13",
    tag: ["apple", "review"],
    title: "Is Apple worth it?",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://source.unsplash.com/1600x900/?apple",
    author: "https://source.unsplash.com/1600x900/?food",
    authorName: "Maria Rodriguez",
    date: "20 January 2022",
    address: "Vaadhoo, Maldives",
    readTime: 6,
    articleData: airPodsCool,
  },
  {
    type: "basic",
    articleId: "article-14",
    tag: ["review", "technology"],
    title: "Realme Narzo 20 Review",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://source.unsplash.com/1600x900/?mobile",
    author: "https://source.unsplash.com/1600x900/?usa",
    authorName: "arthur conan doyle",
    date: "1 December 2025",
    address: "New York, united states ",
    readTime: 6,
    articleData: mackbookReview,
  },
  {
    type: "fancy",
    articleId: "article-15",
    tag: ["Tips & Tricks", "life", "ideas"],
    title: "Not that typical - How To do X",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://source.unsplash.com/1600x900/?life",
    author: "https://source.unsplash.com/1600x900/?tree",
    authorName: "Sarah Brown",
    date: "12 May 2025",
    address: "Colombo, Sri Lanka",
    readTime: 9,
    articleData: packingForTravel,
  },
  {
    type: "basic",
    articleId: "article-16",
    tag: ["review", "technology"],
    title: "Asus Rogue Review",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://source.unsplash.com/1600x900/?asus",
    author: "https://source.unsplash.com/1600x900/?usa",
    authorName: "arthur conan doyle",
    date: "1 March 2025",
    address: "New York, united states ",
    readTime: 8,
    articleData: mackbookReview,
  },
  {
    type: "basic",
    articleId: "article-17",
    tag: ["google", "technology", "computer science"],
    title: "Google - The Big G",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://source.unsplash.com/1600x900/?internet",
    author: "https://source.unsplash.com/1600x900/?india",
    authorName: "Suzan Walker",
    date: "14 July 2023",
    address: "mumbai, India",
    readTime: 13,
    articleData: isChromebookStillaThing,
  },
  {
    type: "basic",
    articleId: "article-18",
    tag: ["code", "technology", "javascript"],
    title: "Know The Gatsby",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://api.otakoyi.com/uploads/content/2020/08/27/1280/what-is-gatsby-js-and-why-use-it_03-208x.png",
    author: "https://source.unsplash.com/1600x900/?tree",
    authorName: "Sarah Brown",
    date: "11 May 2022",
    address: "Kulu, India",
    readTime: 7,
    articleData: learnGatsby,
  },
  {
    type: "basic",
    articleId: "article-19",
    tag: ["book", "read", "review", "life", "goals"],
    title: "Atomic Habits - A book of Habits",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://hautemommyhandbook.files.wordpress.com/2021/03/atomic-habits-1.jpg",
    author: "https://source.unsplash.com/1600x900/?village",
    authorName: "Ivanovich Icanovna",
    date: "25 September 2021",
    address: "london, united kingdom ",
    readTime: 21,
    articleData: eraOfSmartWatches,
  },
  {
    type: "fancy",
    articleId: "article-20",
    tag: ["review", "movie", "horror"],
    title: "The Ring Review",
    desc: "Nunc fringilla turpis tincidunt purus malesuada, vel faucibus mauris finibus.",
    img: "https://source.unsplash.com/1600x900/?horror",
    author: "https://source.unsplash.com/1600x900/?usa",
    authorName: "arthur conan doyle",
    date: "11 November 2025",
    address: "New York, united states ",
    readTime: 9,
    articleData: mackbookReview,
  },
];

export default articles;
